<div [hidden]="!showGadget" class="justify-content-lg-end gadget">
  <div class="title">
    <span translate>{{title}}</span>

  </div>
  <div class="pt-2">
    <div class="bar">
      <div class="section-1"></div>
      <div class="section-2"></div>
      <div class="usage-arrow"></div>
      <div class="usage-text">{{data.typeLabel + data.usageLabel}}</div>
    </div>
    <div class="residual">
      <span translate>Residual Credit</span>:
      &nbsp;
      <b>{{data.typeLabel + data.currentLabel}}</b>
    </div>
    @if (data.current <= 0) {
      <button type="button" class="btn btn-primary" (click)="onBtnClick()">{{btnText | translate}}</button>
    }
  </div>
</div>
